import { render, staticRenderFns } from "./differenceDetail.vue?vue&type=template&id=91958e9c&scoped=true&"
import script from "./differenceDetail.vue?vue&type=script&lang=js&"
export * from "./differenceDetail.vue?vue&type=script&lang=js&"
import style0 from "./differenceDetail.vue?vue&type=style&index=0&id=91958e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91958e9c",
  null
  
)

export default component.exports